import {
  useLocale,
  useTranslation,
} from "~contexts/I18nContext/I18nContext.tsx";

export const NO_VALUE = "–";

export function useVacationDaysFormat() {
  const t = useTranslation();
  const locale = useLocale();

  const parts = (days: number) => {
    const rounded = Math.round(days * 10) / 10 || 0;
    return {
      value: rounded.toLocaleString(locale.code),
      unit: Math.abs(rounded) === 1 ? t.day : t.days,
    };
  };

  const format = (days: number | null | undefined) => {
    if (days == null) {
      return NO_VALUE;
    }
    const { value, unit } = parts(days);
    return `${value} ${unit}`;
  };

  return { parts, format };
}
